/* eslint-disable @typescript-eslint/no-explicit-any */
import { core } from 'types';
import { toEnumString } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const {
  InternalPatronSearchRequest,
  Patron,
  PatronInternalStatusUpdateRequest,
  TextingUnsubscribeRequest,
} = protos;

/**
 * Search patrons
 * @param {Object} request InternalPatronSearchRequest in json format.
 * @param {bool} isInitialRequest Whether this is the initial request.
 * @returns {Object} A redux TockApi action.
 */
export function search(request: any, isInitialRequest: any): ApiAction {
  return {
    TockApi: {
      postProto: '/internal/patron/search',
      request: InternalPatronSearchRequest.fromObject(request),
      type: ClowncarAppConstants.PATRONS_SEARCH,
      context: {
        isInitialRequest,
      },
    },
  };
}

export function deletePatron(patronId: number, closedReason: string): ApiAction {
  return {
    TockApi: {
      deleteProto: `/internal/patron/${patronId}?deleteReason=${closedReason}`,
      type: ClowncarAppConstants.INTERNAL_ACCOUNT_DELETE,
    },
  };
}

export function setPatronStatus(patronId: number, patronStatus: core.Patron.Status): ApiAction {
  return {
    TockApi: {
      putProto: `/internal/patron/status/update`,
      request: PatronInternalStatusUpdateRequest.fromObject({
        patronId,
        status: toEnumString(Patron.Status, patronStatus),
      }),
      type: ClowncarAppConstants.INTERNAL_ACCOUNT_STATUS_UPDATE,
    },
  };
}

export function toggleGlobalTextingUnsubscribed(
  patronId: number,
  unsubscribed: boolean
): ApiAction {
  return {
    TockApi: {
      postProto: `/internal/patron/texting/unsubscribe`,
      request: TextingUnsubscribeRequest.fromObject({
        patronId,
        unsubscribed,
      }),
      type: ClowncarAppConstants.INTERNAL_GLOBAL_TEXTING_UNSUBSCRIBE,
    },
  };
}

export function resetFailedLoginAttempts(patronId: number) {
  return {
    TockApi: {
      postProto: `/internal/patron/${patronId}/reset-failed-logins`,
      type: ClowncarAppConstants.PATRON_RESET_FAILED_LOGIN_ATTEMPTS,
    },
  };
}
